import {pageInfo, detail, rePush} from '../api/index';
import {Message} from 'element-ui';
import {listOrigin, listDest} from "../../../../../api";
const orderSignLog = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    detailObj: null,
    rePushObj: null,
    originObj: null,
    destObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [true, item.dealStatus == '处理失败'] }));
    },
    DETAIL(state, data) {
      state.detailObj = data.obj;
    },
    RE_PUSH(state, data) {
      state.rePushObj = data;
    },
    LIST_ORIGIN(state, data) {
      state.originObj = data.obj;
    },
    LIST_DEST(state, data) {
      state.destObj = data.obj;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async detail({commit}, obj) {
      let resp = await detail(obj);
      commit('DETAIL', resp);
    },
    async rePush({commit}, obj) {
      let resp = await rePush(obj);
      commit('RE_PUSH', resp);
    },
    async listOrigin({commit}, obj) {
      let resp = await listOrigin(obj);
      commit('LIST_ORIGIN', resp);
    },
    async listDest({commit}, obj) {
      let resp = await listDest(obj);
      commit('LIST_DEST', resp);
    },
  }
}
export default orderSignLog



// WEBPACK FOOTER //
// ./src/page/log/mdlzsct/orderSignLog/store/orderSignLog.store.js